import { getStrings } from "../../Shared/Reservation/StringResources";
import { IErrorDictionary } from "../ApiCalls/ApiCallReducer";
import { IHydratedApiCallState } from "../ApiCalls/Models";
import { currentLanguage } from "../Settings";

const defaultNumberFormatter = new Intl.NumberFormat(currentLanguage, { minimumFractionDigits: 0, maximumFractionDigits: 2 });

export const formatteraTal = (tal?: number, suffix?: string, maximumFractionDigits?: number, minimumFractionDigits?: number) =>
{
	if (tal === undefined)
		return "-";

	const numberFormatter = maximumFractionDigits !== undefined ? Intl.NumberFormat(currentLanguage, { minimumFractionDigits: minimumFractionDigits || 0, maximumFractionDigits }) : defaultNumberFormatter;
	const pretty = numberFormatter.format(tal);
	return suffix ? `${pretty} ${suffix}` : pretty;
}

const errorStrings = getStrings().component.s3Errors;

export function getErrorMessages(actionType: string, apicalls: IHydratedApiCallState)
{
	const loadingState = apicalls.getLoadingState(actionType);
	if (loadingState !== "error")
		return null;

	const e = apicalls.getError(actionType);
	return getErrorAsStrings(e);
}

export function getErrorAsStrings(error: string|IErrorDictionary) : string[]
{
	if (!error)
		return null;
	if (typeof(error) === "string")
		return [error];

	return Object.getOwnPropertyNames(error).map(p => {
		return errorStrings[p] || error[p].join(", ");
	});
}

export function getJSONFromAttribute<T>(element: HTMLElement, attributeName: string, fallbackValue?: T)
{
	const str = element.getAttribute(attributeName);
	if (!str)
		return fallbackValue || {} as T;
	return JSON.parse(decodeURIComponent(str)) as T;
}